"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_1_BYTE = exports.OVERFLOW_4_BYTES = exports.OVERFLOW_2_BYTES = exports.OVERFLOW_1_BYTE = exports.MAX_4_BYTES = exports.maxBigInt = exports.minBigInt = void 0;
/** Lowest value that can be encoded directly as (negative) integer */
exports.minBigInt = BigInt("-18446744073709551616"); // -(2n ** 64n)
/** Highest value that can be encoded directly as (positive) integer */
exports.maxBigInt = BigInt("18446744073709551615"); // (2n ** 64n) - 1n
exports.MAX_4_BYTES = 4294967295;
exports.OVERFLOW_1_BYTE = 0x100;
exports.OVERFLOW_2_BYTES = 0x10000;
exports.OVERFLOW_4_BYTES = 0x100000000;
exports.MAX_1_BYTE = 255;
